export const assistantAppsGoogleClientId = '55960sasasasasasas';
export const apiPatronOAuthClientId = 'ZpWkiLDiGsMmBM7nmSgr60SHrF0fV-jlbFmkt1d2Uy04DcgXIOUebxrKCeIO4S1G';

// PROD
export const assistantAppsAppGuid = 'dd795031-cf23-9e62-5f90-d8c469e77c58';
export const assistantAppsApiUrl = 'https://api.assistantapps.com';
export const apiPatronOAuthResponseUrl = 'https://api.assistantapps.com/OAuth/Patreon';

// DEV
// export const assistantAppsAppGuid = '589405b4-e40f-4cd9-b793-6bf37944ee09';
// export const assistantAppsApiUrl = 'http://localhost:55555';
// export const apiPatronOAuthResponseUrl = 'https://b389-85-144-243-17.eu.ngrok.io/OAuth/Patreon';

// export const whatIsNewGuid = '495e8777-5201-4245-b453-662ab46f9123';
export const currentServerVersionNum = 70;